// Quote view controller (mode 'view'): the page a customer opens from a link.
//
// THERE ARE TWO KINDS OF LINK and they are told apart by the token.
//
// 1. A RECORD link, ?q=<qid>&k=<token>&c=<contact>, which the Trade Desk makes.
//    The page holds no prices: it asks the quote service for the record and
//    prints what comes back, so the number the customer reads is the number the
//    server worked out and the number the draft order is built from. Accepting
//    posts the id, the token and the customer's own words, and the service
//    creates the draft. Nothing goes near the cart.
//
// 2. A LEGACY link, ?q=<compressed> or ?items=, from the old rep tool. The whole
//    quote was in the URL, so every field is escaped (X1) and clamped on read
//    (X3), and a payload carrying a discount or a priced add-on routes to a
//    contact card, because the cart charges full retail and would silently drop
//    them. Kept so links already sent still open.
//
// The window surface is exactly the three handlers the markup calls (X9).
(function () {
  'use strict';
  var cfgEl = document.querySelector('script.qb-config');
  var CFG = {};
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { CFG = {}; }
  var SECTION_ID = CFG.sectionId || '';
  var NS = 'QB_' + SECTION_ID.replace(/-/g, '_');
  var E = window.QBEngine;
  var esc = E.esc, fmt = E.fmt, TAX = E.TAX;
  var extractSizeString = E.extractSizeString;
  var MAX_D = typeof CFG.maxDiscountPct === 'number' ? CFG.maxDiscountPct : 30;
  var PHONE = '1-866-326-8321';

  var el = function (id) { return document.getElementById(id + '-' + SECTION_ID); };
  var productCache = {};
  var sharedCart = [];
  var quoteMeta = { quoteNum: '', addonsNote: '', blocked: false };

  // Set only for a record link. Its presence is what keeps the cart out of the
  // accept path: a record quote is priced by the service and settled by a draft
  // order, so there is nothing here for /cart/add.js to do.
  var REC = null;

  // Every refusal the service can give a customer, said in words they can act
  // on. A link that is dead is not the same as a service that is down, and a
  // customer who is told the difference knows whether to phone or to wait.
  var MSG = {
    revoked: 'This quote link is no longer active. Ask your Eco-Tech contact to send a new one, or call ' + PHONE + '.',
    expired: 'This quote has expired. Ask your Eco-Tech contact for an updated one, or call ' + PHONE + '.',
    busy: 'This link has been opened several times in a row. Give it a few minutes and try again.',
    down: 'The quote service is not available right now. Try again in a few minutes, or call ' + PHONE + '.',
    missing: 'This quote link could not be loaded. Ask your Eco-Tech contact to resend it, or call ' + PHONE + '.',
    accept: 'We could not record your acceptance just now. Try again, or call ' + PHONE + ' and we will take it from there.'
  };

  function messageFor(status, error) {
    if (error === 'revoked') return MSG.revoked;
    if (error === 'expired') return MSG.expired;
    if (error === 'rate_limited' || status === 429) return MSG.busy;
    if (status >= 500 || error === 'not_configured') return MSG.down;
    return MSG.missing;
  }

  async function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    try {
      var r = await fetch('/products/' + encodeURIComponent(handle) + '.js');
      if (!r.ok) return null;
      var data = await r.json();
      productCache[handle] = data;
      return data;
    } catch (e) { return null; }
  }

  function showNoQuote() {
    var n = el('noQuote');
    if (n) n.style.display = 'block';
    var sv = el('sharedView');
    if (sv) sv.style.display = 'none';
  }

  function renderErrorCard(msg) {
    var sv = el('sharedView');
    if (sv) {
      sv.classList.add('active');
      sv.innerHTML = '<div style="padding:40px;text-align:center;color:#4A4A4A;font-size:1.4rem;">' + esc(msg) + '</div>';
    }
  }

  // A discounted or priced-add-on LEGACY payload cannot check out through the
  // cart at its quoted total, so acceptance routes to the team instead.
  function renderContactCta() {
    var acc = el('acceptanceSection');
    if (!acc) return;
    acc.innerHTML =
      '<h3 class="quote-builder__acceptance-title">Ready to go ahead?</h3>' +
      '<p class="quote-builder__acceptance-sub">This quote carries pricing the online cart cannot apply. To accept it at the quoted numbers, reply to the message it came with, email <a href="mailto:info@ecotechnology.ca">info@ecotechnology.ca</a>, or call ' + PHONE + ' and we\'ll finalize your order.</p>';
  }

  function mr(label, val, full) {
    return val ? '<div class="quote-builder__shared-meta-row ' + (full ? 'quote-builder__shared-meta-full' : '') + '"><span class="quote-builder__shared-meta-label">' + label + ':</span><span class="quote-builder__shared-meta-val">' + esc(val) + '</span></div>' : '';
  }

  function money$(label, amount, cls) {
    return '<div class="quote-builder__shared-total-row' + (cls || '') + '"><span>' + esc(label) + '</span><span class="amount">' + amount + '</span></div>';
  }

  function longDate(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' });
  }

  function parseItems(itemsStr) {
    return String(itemsStr || '').split(',').slice(0, 60).map(function (part) {
      var p = part.split(':');
      if (p.length >= 5) {
        return { handle: p[0].trim(), variantId: parseInt(p[1]) || null, qty: clampQty(p[2]),
                 projectArea: parseFloat(p[3]) || 0, projectThickness: parseInt(p[4]) || 0 };
      } else if (p.length === 3) {
        return { handle: p[0].trim(), variantId: parseInt(p[1]) || null, qty: clampQty(p[2]), projectArea: 0, projectThickness: 0 };
      }
      return { handle: p[0].trim(), variantId: null, qty: clampQty(p[1]), projectArea: 0, projectThickness: 0 };
    }).filter(function (i) { return i.handle && /^[a-z0-9-]+$/i.test(i.handle); });
  }

  function clampQty(v) {
    var n = parseInt(v) || 1;
    return Math.min(Math.max(n, 1), 999);
  }

  // ------------------------------------------------------------------ record

  // The customer's own words ride in the link rather than in the database
  // (J. Nelson 2026-09-08): their name and address, the job they called it, and
  // any note against a line. NOT their email or phone, which nothing downstream
  // uses and which have no business sitting in a URL that gets forwarded and
  // logged. Base64 of UTF-8 JSON, the inverse of what the rep plugin writes. A
  // blob that will not decode is simply absent: the quote is still perfectly
  // readable without it.
  function decodeWho(raw) {
    if (!raw) return {};
    try {
      var o = JSON.parse(decodeURIComponent(escape(atob(raw))));
      if (!o || typeof o !== 'object') return {};
      if (!Array.isArray(o.nt)) o.nt = [];
      return o;
    } catch (e) { return {}; }
  }

  async function loadRecord(qid, token) {
    var base = String(CFG.proxyBase || '/apps/qb').replace(/\/$/, '');
    var r, j = null;
    try {
      r = await fetch(base + '/qt/get?qid=' + encodeURIComponent(qid) + '&k=' + encodeURIComponent(token),
        { headers: { 'Accept': 'application/json' } });
    } catch (e) {
      renderErrorCard(MSG.down);
      return;
    }
    try { j = await r.json(); } catch (e) { j = null; }
    if (!r.ok || !j || !j.ok || !j.quote) {
      renderErrorCard(messageFor(r.status, j && j.error));
      return;
    }
    REC.doc = j;
    renderRecord(j);
  }

  function renderRecord(doc) {
    var sv = el('sharedView');
    if (sv) sv.classList.add('active');
    var q = doc.quote || {};
    var m = q.money || {};
    var who = REC.who || {};
    quoteMeta.quoteNum = doc.number || '';

    var metaHtml = '';
    metaHtml += mr('Quote #', doc.number);
    if (doc.expires_at) metaHtml += mr('Valid until', longDate(doc.expires_at));
    if (who.n) metaHtml += mr('Prepared for', who.n);
    if (who.co) metaHtml += mr('Company', who.co);
    // No email or phone row. The link stopped carrying them (2026-09-10): the
    // worker never used them, and a customer does not need their own contact
    // details read back to them at the cost of putting them in a URL.
    if (who.cl) metaHtml += mr('Colour code', who.cl);
    if (who.j) metaHtml += mr('Project', who.j, true);
    if (who.no) metaHtml += mr('Notes', who.no, true);
    if (who.a) metaHtml += mr('Project Address', who.a, true);
    var metaEl = el('sharedMeta');
    if (metaEl) metaEl.innerHTML = metaHtml;

    // Lines, printed from the record. No product is looked up live: a price
    // edited in the store after the quote was sent must not change what the
    // customer is reading.
    var itemsHtml = '';
    // The per-line savings the worker worked out at save. NOT computed here:
    // this page prints the server's numbers and never does arithmetic, so that
    // a price edited after the quote was sent cannot change what is on screen.
    // A quote saved before this existed has no parts and renders as it always
    // did (2026-09-10).
    var parts = Array.isArray(m.parts) ? m.parts : null;
    var svcParts = Array.isArray(m.svcParts) ? m.svcParts : null;
    // Struck-through retail is shown only when the discount is the customer's
    // to see. Hidden means hidden: they see the lower prices and no comparison.
    var showSaving = q.show !== false && Number(m.discountAmt) > 0;

    // One line's money cell: what it was, what it is. `net` is authoritative --
    // it is what the draft order charges and what the subtotal sums.
    function priceCell(part, fallback) {
      if (!part) return '<div class="quote-builder__shared-item-price">' + fmt(fallback) + '</div>';
      var saved = Number(part.disc) || 0;
      if (!(showSaving && saved > 0)) {
        return '<div class="quote-builder__shared-item-price">' + fmt(Number(part.net) || 0) + '</div>';
      }
      return '<div class="quote-builder__shared-item-price">' +
        '<span class="quote-builder__shared-was">' + fmt(Number(part.gross) || 0) + '</span>' +
        '<span class="quote-builder__shared-now">' + fmt(Number(part.net) || 0) + '</span>' +
      '</div>';
    }

    // And the unit prices under the name, the way the invoice shows them.
    function eachLine(part) {
      if (!part || !showSaving || !(Number(part.disc) > 0)) return '';
      return '<div class="quote-builder__shared-item-each">' +
        '<span class="quote-builder__shared-was">' + fmt(Number(part.unitGross) || 0) + '</span>' +
        '<span class="quote-builder__shared-now">' + fmt(Number(part.unitNet) || 0) + '</span>' +
        ' each</div>';
    }

    (q.lines || []).forEach(function (l, i) {
      var qty = Number(l.quantity) || 0;
      var part = parts && parts[i];
      var lineTotal = (Number(l.price) || 0) * qty;
      var props = l.properties || {};
      var bits = [];
      ['Room', 'Substrate', 'Area'].forEach(function (k) { if (props[k]) bits.push(props[k]); });
      if (props.Color) bits.push(props.Color);
      var note = String((who.nt && who.nt[i]) || '');
      itemsHtml += '<div class="quote-builder__shared-item">' +
        '<div class="quote-builder__shared-item-info">' +
          '<div class="quote-builder__shared-item-name">' + esc(l.name || '') + '</div>' +
          (bits.length ? '<div class="quote-builder__shared-item-variant">' + esc(bits.join(' / ')) + '</div>' : '') +
          (note ? '<div class="quote-builder__shared-item-project">' + esc(note) + '</div>' : '') +
          eachLine(part) +
        '</div>' +
        '<div class="quote-builder__shared-item-qty">× ' + qty + '</div>' +
        priceCell(part, lineTotal) +
      '</div>';
    });

    var services = Array.isArray(q.services) ? q.services : [];
    if (services.length) {
      itemsHtml += '<div class="quote-builder__shared-item" style="border-top:1px dashed var(--qb-border);padding-top:8px;margin-top:4px;">' +
        '<div class="quote-builder__shared-item-info" style="flex:1;font-size:1.2rem;font-weight:700;color:var(--qb-charcoal-light);letter-spacing:0.5px;text-transform:uppercase;">Additional Services</div>' +
      '</div>';
      services.forEach(function (s, i) {
        var qty = Number(s.qty) || 1;
        var part = svcParts && svcParts[i];
        itemsHtml += '<div class="quote-builder__shared-item">' +
          '<div class="quote-builder__shared-item-info"><div class="quote-builder__shared-item-name">' + esc(s.label || 'Additional service') + '</div>' +
            eachLine(part) +
          '</div>' +
          '<div class="quote-builder__shared-item-qty">× ' + qty + '</div>' +
          priceCell(part, (Number(s.price) || 0) * qty) +
        '</div>';
      });
    }
    var itemsEl = el('sharedItems');
    if (itemsEl) itemsEl.innerHTML = itemsHtml;

    // Totals are PRINTED, not worked out. The service did the arithmetic and a
    // draft order will be built from the same numbers.
    var subAll = (Number(m.sub) || 0) + (Number(m.serviceSub) || 0);
    var disc = Number(m.discountAmt) || 0;
    // The Subtotal is the sum of the line totals printed above it, always. It
    // used to be gross when the discount was shown and net when it was hidden,
    // and the lines were gross either way, so with the discount hidden the page
    // did not add up (adversarial review 2026-09-10).
    var netSub = m.netSub != null ? Number(m.netSub) : (subAll - disc);
    var showDisc = q.show !== false && disc > 0;
    var totalsHtml = money$('Subtotal', fmt(parts ? netSub : (showDisc ? subAll : subAll - disc)));
    if (showDisc) {
      var pct = String(Number(q.pct) || 0);
      // With the saving already struck through on every line, this row states
      // the total rather than subtracting it a second time: the lines above are
      // already net. On a quote saved before the parts existed the lines are
      // gross, so it still has to be a subtraction.
      totalsHtml += parts
        ? money$('You saved (' + pct + '%)', fmt(disc), ' saved')
        : money$('Discount (' + pct + '%)', '−' + fmt(disc), ' discount');
    }
    totalsHtml += money$(m.taxLabel || (TAX[q.province] || TAX.SK).label, fmt(Number(m.taxAmt) || 0));
    totalsHtml += money$('Total', fmt(Number(m.total) || 0), ' grand');
    var totalsEl = el('sharedTotals');
    if (totalsEl) totalsEl.innerHTML = totalsHtml;

    // The cart plays no part in a record quote.
    var cartSection = el('cartSection');
    if (cartSection) cartSection.style.display = 'none';

    if (doc.status === 'accepted' || doc.status === 'ordered') {
      // The typed name is never stored (it is a person's name), so a reload
      // shows the name in their own link, or nothing at all.
      REC.done = true;
      showAccepted(who.n || '', doc.accepted_at || '', doc.number);
      return;
    }
    dressAcceptance();
  }

  // The words on the accept card. A draft order is not an invoice, and a
  // customer who thinks it is stops reading, so the card says plainly that
  // nothing is charged here.
  function dressAcceptance() {
    var acc = el('acceptanceSection');
    if (!acc) return;
    var title = acc.querySelector('.quote-builder__acceptance-title');
    if (title) title.textContent = 'Accept this quote';
    var sub = acc.querySelector('.quote-builder__acceptance-sub');
    if (sub) sub.textContent = 'Type your name to accept these numbers. Nothing is charged here. We confirm the details with you and send the invoice.';
    var btn = el('acceptBtn');
    if (btn) btn.textContent = 'Accept quote';
  }

  function acceptError(msg) {
    var acc = el('acceptanceSection');
    if (!acc) return;
    var id = 'acceptErr-' + SECTION_ID;
    var box = document.getElementById(id);
    if (!box) {
      box = document.createElement('div');
      box.id = id;
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin-top:12px;padding:10px 12px;border-radius:4px;background:#fef2f2;color:#991b1b;font-size:1.3rem;';
      acc.appendChild(box);
    }
    box.textContent = msg;
    var btn = el('acceptBtn');
    if (btn) { btn.disabled = false; btn.textContent = 'Accept quote'; }
  }

  function showAccepted(signature, iso, number) {
    var acc = el('acceptanceSection');
    if (acc) acc.style.display = 'none';
    var acceptedSection = el('acceptedSection');
    if (acceptedSection) acceptedSection.classList.add('visible');
    var sig = el('acceptedSig');
    if (sig) sig.textContent = signature;
    var d = iso ? new Date(iso) : new Date();
    if (isNaN(d.getTime())) d = new Date();
    var date = el('acceptedDate');
    if (date) date.textContent = 'Accepted on ' + d.toLocaleDateString('en-CA', {
      year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit'
    });
    var redirect = document.querySelector('#acceptedSection-' + SECTION_ID + ' .quote-builder__accepted-redirect');
    if (redirect) {
      redirect.innerHTML = '<span>' + esc('Quote ' + (number || quoteMeta.quoteNum) +
        ' is accepted. We have it, and your Eco-Tech contact will be in touch to finalize the order.') + '</span>';
    }
  }

  // What this request carries: the id, the token, the typed name and the words
  // that were always the customer's. What it cannot carry: a price, a quantity,
  // a percentage or a product. Those live in the record.
  async function acceptRecord() {
    if (REC.done || REC.sending) return;
    var input = el('signatureInput');
    if (!input) return;
    var signature = (input.value || '').trim();
    if (signature.length < 2) { input.focus(); return; }

    var btn = el('acceptBtn');
    REC.sending = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }

    var who = REC.who || {};
    var base = String(CFG.proxyBase || '/apps/qb').replace(/\/$/, '');
    var body = {
      v: 1, qid: REC.qid, k: REC.k, name: signature,
      job: who.j || '',
      colour: who.cl || '',
      memo: who.no || '',
      notes: Array.isArray(who.nt) ? who.nt : [],
      // The words that were always the customer's. Not an account id: the
      // record holds that, so an edited link cannot re-point the order.
      contact: { n: who.n || '', co: who.co || '', a: who.a || '' }
    };
    var r, j = null;
    try {
      r = await fetch(base + '/qt/accept', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
      });
    } catch (e) {
      REC.sending = false;
      acceptError(MSG.down);
      return;
    }
    try { j = await r.json(); } catch (e) { j = null; }
    REC.sending = false;
    if (!r.ok || !j || !j.ok) {
      acceptError(r.status >= 500 || !j ? MSG.accept : messageFor(r.status, j.error));
      return;
    }
    // 'accepted' with pending true means the draft has not landed yet. That is
    // the service's problem and it knows about it; the customer accepted, and
    // telling them otherwise would be false.
    REC.done = true;
    showAccepted(signature, j.accepted_at || '', j.number);
  }

  // ------------------------------------------------------------------ legacy

  async function renderQuote(data) {
    // data uses the compressed-payload keys (see qb-engine encodeQuoteData)
    var sv = el('sharedView');
    if (sv) sv.classList.add('active');

    var discount = Math.min(Math.max(parseFloat(data.d) || 0, 0), MAX_D);
    var showDiscount = !data.h;
    var province = /^[A-Z]{2}$/.test(data.p || '') ? data.p : 'SK';
    var addons = Array.isArray(data.addons) ? data.addons : [];
    quoteMeta.quoteNum = data.n || '';

    var items = parseItems(data.i);
    await Promise.all(items.map(function (i) { return fetchProduct(i.handle); }));

    // Meta rows (every value escaped - payloads are attacker-controllable)
    var metaHtml = '';
    if (data.n) metaHtml += mr('Quote #', data.n);
    metaHtml += mr('Date', new Date().toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' }));
    if (data.c) metaHtml += mr('Prepared for', data.c);
    if (data.co) metaHtml += mr('Company', data.co);
    if (data.e) metaHtml += mr('Email', data.e);
    if (data.ph) metaHtml += mr('Phone', data.ph);
    if (data.cl) metaHtml += mr('Color Selection', data.cl);
    if (data.a) metaHtml += mr('Project Address', data.a, true);
    if (data.m) metaHtml += mr('Notes', data.m, true);
    var metaEl = el('sharedMeta');
    if (metaEl) metaEl.innerHTML = metaHtml;

    // Items
    var sub = 0;
    var itemsHtml = '';
    sharedCart = [];
    items.forEach(function (item) {
      var sp = productCache[item.handle];
      if (!sp) return;
      var variantId = item.variantId, price, variantTitle;
      var variant = variantId && sp.variants ? sp.variants.find(function (v) { return v.id === variantId; }) : null;
      if (variant) {
        price = variant.price / 100;
        variantTitle = variant.title !== 'Default Title' ? variant.title : '';
      } else {
        variantId = E.getVariantId(sp);
        price = E.getPrice(sp);
        variantTitle = E.getVariantTitle(sp);
      }
      var lineTotal = price * item.qty;
      sub += lineTotal;
      sharedCart.push({ handle: item.handle, variantId: variantId, qty: item.qty });

      var sizeDisplay = extractSizeString(variantTitle);
      var projectDisplay = '';
      if (item.projectArea > 0) {
        projectDisplay = item.projectArea.toFixed(1) + ' m² / ' + (item.projectArea * 10.764).toFixed(0) + ' ft²';
        if (item.projectThickness > 0) projectDisplay += ' @ ' + item.projectThickness + 'mm';
      }
      itemsHtml += '<div class="quote-builder__shared-item">' +
        '<div class="quote-builder__shared-item-info">' +
          '<div class="quote-builder__shared-item-name">' + esc(sp.title) + '</div>' +
          (sizeDisplay ? '<div class="quote-builder__shared-item-variant">' + esc(sizeDisplay) + '</div>' : '') +
          (projectDisplay ? '<div class="quote-builder__shared-item-project">' + projectDisplay + '</div>' : '') +
        '</div>' +
        '<div class="quote-builder__shared-item-qty">× ' + item.qty + '</div>' +
        '<div class="quote-builder__shared-item-price">' + fmt(lineTotal) + '</div>' +
      '</div>';
    });

    var addonPriced = false;
    if (addons.length) {
      itemsHtml += '<div class="quote-builder__shared-item" style="border-top:1px dashed var(--qb-border);padding-top:8px;margin-top:4px;">' +
        '<div class="quote-builder__shared-item-info" style="flex:1;font-size:1.2rem;font-weight:700;color:var(--qb-charcoal-light);letter-spacing:0.5px;text-transform:uppercase;">Additional Services</div>' +
      '</div>';
      var noteParts = [];
      addons.forEach(function (a) {
        var lineTotal = a.qty * a.price;
        if (lineTotal > 0) addonPriced = true;
        sub += lineTotal;
        noteParts.push((a.desc || 'Service') + ' ×' + a.qty + ' @ ' + fmt(a.price));
        itemsHtml += '<div class="quote-builder__shared-item">' +
          '<div class="quote-builder__shared-item-info"><div class="quote-builder__shared-item-name">' + esc(a.desc || 'Additional Service') + '</div></div>' +
          '<div class="quote-builder__shared-item-qty">× ' + a.qty + '</div>' +
          '<div class="quote-builder__shared-item-price">' + fmt(lineTotal) + '</div>' +
        '</div>';
      });
      quoteMeta.addonsNote = noteParts.join('; ').slice(0, 500);
    }
    var itemsEl = el('sharedItems');
    if (itemsEl) itemsEl.innerHTML = itemsHtml;

    // Totals (same math as the rep panel)
    var addonDiscTotal = addons.reduce(function (s, a) { return s + (a.disc ? a.qty * a.price : 0); }, 0);
    var addonFullTotal = addons.reduce(function (s, a) { return s + (!a.disc ? a.qty * a.price : 0); }, 0);
    var productOnlySub = sub - addonDiscTotal - addonFullTotal;
    var discBase = productOnlySub + addonDiscTotal;
    var discAmt = discBase * (discount / 100);
    var after = discBase - discAmt + addonFullTotal;
    var t = TAX[province] || TAX.SK;
    var taxAmt = after * ((t.gst + t.pst) / 100);
    var grand = after + taxAmt;

    var totalsHtml = money$('Subtotal', fmt(sub));
    if (discount > 0 && showDiscount) {
      totalsHtml += money$('Discount (' + discount + '%)', '−' + fmt(discAmt), ' discount');
    } else if (discount > 0 && !showDiscount) {
      totalsHtml = money$('Subtotal', fmt(after));
    }
    totalsHtml += money$(t.label, fmt(taxAmt));
    totalsHtml += money$('Total', fmt(grand), ' grand');
    var totalsEl = el('sharedTotals');
    if (totalsEl) totalsEl.innerHTML = totalsHtml;

    // Cart-accept only works when the cart will charge what the quote shows.
    if (discount > 0 || addonPriced) {
      quoteMeta.blocked = true;
      renderContactCta();
    }
  }

  // ------------------------------------------------------------------- boot

  async function init() {
    var p = new URLSearchParams(window.location.search);
    var qid = p.get('q') || '';
    var token = p.get('k') || '';
    // The token is what makes it a record link: a compressed legacy payload
    // never carries one, and a qid is short and upper-case base32.
    if (token && /^[0-9A-Z]{4,32}$/.test(qid) && CFG.proxyBase) {
      REC = { qid: qid, k: token, who: decodeWho(p.get('c')), doc: null, done: false, sending: false };
      await loadRecord(qid, token);
      return;
    }
    if (qid) {
      var data = E.decodeQuoteData(qid);
      if (!data) {
        renderErrorCard('Unable to load quote. The link may be invalid or expired.');
        return;
      }
      data = E.clampQuote(data, MAX_D);
      // clampQuote normalizes d/strings/addons; the x record-string form
      // arrives pre-split from the rep payload
      if (!data.addons && data.x) {
        data.addons = String(data.x).split('\x1E').map(function (row) {
          var q = row.split('\x1F');
          return { desc: q[0] || '', qty: parseInt(q[1]) || 1, price: parseFloat(q[2]) || 0, disc: q[3] === '1' };
        });
        data = E.clampQuote(data, MAX_D);
      }
      await renderQuote(data);
      return;
    }
    if (p.get('items')) {
      await renderQuote({
        i: p.get('items') || '',
        d: parseFloat(p.get('discount')) || 0,
        h: p.get('show_discount') === 'false' ? 1 : 0,
        p: p.get('province') || 'SK',
        c: (p.get('customer') || '').slice(0, 120),
        n: (p.get('quote_num') || '').slice(0, 40),
        m: (p.get('notes') || '').slice(0, 2000)
      });
      return;
    }
    showNoQuote();
  }

  function checkSignature() {
    var input = el('signatureInput');
    var btn = el('acceptBtn');
    if (!input || !btn) return;
    btn.classList.toggle('ready', (input.value || '').trim().length >= 2);
  }

  function acceptQuote() {
    if (REC) return acceptRecord();
    if (quoteMeta.blocked) return;
    var input = el('signatureInput');
    if (!input) return;
    var signature = (input.value || '').trim();
    if (signature.length < 2) { input.focus(); return; }

    var acc = el('acceptanceSection');
    if (acc) acc.style.display = 'none';
    var acceptedSection = el('acceptedSection');
    if (acceptedSection) acceptedSection.classList.add('visible');
    var sig = el('acceptedSig');
    if (sig) sig.textContent = signature;
    var date = el('acceptedDate');
    if (date) date.textContent = 'Accepted on ' + new Date().toLocaleDateString('en-CA', {
      year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit'
    });
    quoteMeta.signature = signature;
    quoteMeta.acceptedAt = new Date().toISOString();
    setTimeout(addAllToCart, 3000);
  }

  async function addAllToCart() {
    if (REC) return;                       // a record quote never touches the cart
    if (!sharedCart.length) return;
    var btn = el('addAllCartBtn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding to cart...'; }

    var successCount = 0;
    var failedNames = [];
    for (var idx = 0; idx < sharedCart.length; idx++) {
      var item = sharedCart[idx];
      if (!item.variantId) { failedNames.push(item.handle); continue; }
      try {
        var r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.variantId, quantity: item.qty })
        });
        if (r.ok) successCount++;
        else failedNames.push(item.handle);
      } catch (e) { failedNames.push(item.handle); }
    }

    // Redirect only when the whole quote landed; a partial add would check
    // out an order that quietly differs from the accepted quote.
    if (successCount === sharedCart.length && successCount > 0) {
      // Stamp the acceptance on the cart so the order carries the quote
      // identity (X4 minimal; a record quote settles by draft order instead).
      try {
        var attrs = {};
        if (quoteMeta.quoteNum) attrs['Quote #'] = quoteMeta.quoteNum;
        if (quoteMeta.signature) {
          attrs['Quote accepted by'] = quoteMeta.signature;
          attrs['Quote accepted at'] = quoteMeta.acceptedAt;
        }
        if (quoteMeta.addonsNote) attrs['Additional services'] = quoteMeta.addonsNote;
        if (Object.keys(attrs).length) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        }
      } catch (e) { /* attributes are best-effort */ }
      window.location.href = '/cart';
    } else {
      var redirectMsg = document.querySelector('#acceptedSection-' + SECTION_ID + ' .quote-builder__accepted-redirect');
      if (redirectMsg) redirectMsg.style.display = 'none';
      var cartSection = el('cartSection');
      if (cartSection) cartSection.classList.add('visible');
      var msg = el('cartMsg');
      if (msg) {
        msg.style.display = 'block';
        msg.style.background = '#fef2f2';
        msg.style.color = '#991b1b';
        msg.textContent = successCount > 0
          ? 'Added ' + successCount + ' of ' + sharedCart.length + ' lines. Not added: ' + failedNames.join(', ') + '. Review your cart before checkout, or call ' + PHONE + '.'
          : 'Unable to add products. Please try again.';
      }
      if (btn) { btn.textContent = 'Try Again'; btn.disabled = false; }
    }
  }

  // Minimal surface: exactly what the shared-view markup calls (X9).
  window[NS] = { checkSignature: checkSignature, acceptQuote: acceptQuote, addAllToCart: addAllToCart };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
